<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.trip_road_report')"/>
        <road-report-search @search="fetchReports"/>
        <div class="trip-results">
            <div class="row" style="height: 50em;">
                <!-- Trip list -->
                <div :class="{'col-md-6': showDetails, 'col-12': !showDetails}">
                    <road-report-list :reports="results" @rowClicked="showRowTrips"/>
                </div>
                <!-- Map -->
                <div v-if="showDetails" class="col-md-6 d-flex flex-column pb-0">
                    <div class="flex-fill position-relative" style="border-radius: .75em; border: 1px solid #BCBCBC; overflow: hidden; background-color: #FFFFFF ">
                        <road-report-trips ref="trips" :params="tripParams" :geojson="roads"/>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import {inject, nextTick} from "vue";
import RoadReportSearch from "./RoadReportSearch.vue";
import RoadReportList from "./RoadReportList.vue";
import Navbar from "../../utils/Navbar.vue";
import RoadReportTrips from "./RoadReportTrips.vue";


export default {
    name: 'RoadReports',
    components: {
        RoadReportTrips,
        Navbar,
        RoadReportList,
        RoadReportSearch,
    },
    mixins: [timeUtils, restApi],
    props: {
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            results: [],
            roads: null,
            loading: false,
            showDetails: false,
            tripParams: {},
            searchParams: null
        }
    },
    methods: {

        fetchReports: function (params) {
            this.showDetails = false
            this.searchParams = params
            this.loading = true
            this.results = []
            this.restFetchParams(this.roadReportUrl, params, this.handleResponse)
        },

        handleResponse: function (response) {
            this.loading = false
            if (response && response.data) {
                this.results = response.data.results
                this.roads = response.data.roads
            }
        },

        showRowTrips: function (row) {
            const start = new Date(row.date + "T00:00:00");
            const end = new Date(row.date + "T23:59:59.999");
            const newParams = {
                from: start.toISOString(),
                to: end.toISOString(),
                orderId: row.order,
                contractId: this.searchParams.contract,
                roadNum: this.searchParams.roadNum,
                secNum: this.searchParams.secNum
            }
            this.showDetails = true
            this.$nextTick(() => {
                this.tripParams = newParams
            })
        },

    }
}
</script>
<style>
</style>
